/* Visual targeting only in the Shopify editor; no storefront dependency. */
(() => {
  if (!window.Shopify?.designMode) return;
  let marked = [];
  const clear = () => { marked.forEach(el => el.classList.remove('gm-design-target-active')); marked = []; };
  document.addEventListener('shopify:block:select', event => {
    clear();
    const id = event.detail?.blockId;
    const panel = event.target.closest?.('.gm-design-panel') || [...document.querySelectorAll('.gm-design-panel')].find(el => el.dataset.gmDesignPanel === id);
    if (!panel) return;
    try { marked = [...document.querySelectorAll(panel.dataset.gmDesignTarget)]; } catch { return; }
    marked.forEach(el => el.classList.add('gm-design-target-active'));
    marked[0]?.scrollIntoView({behavior:'instant',block:'center'});
  });
  ['shopify:block:deselect','shopify:section:unload','shopify:section:load'].forEach(name => document.addEventListener(name,clear));
})();
